// ELEMENT UI 配置
// import "@/styles/element-variables.scss";
import Vue from "vue";

export function initMessage(Message) {
  Vue.prototype.$message = function (option) {
    if (option) {
      if (option.showClose === undefined) {
        option.showClose = true;
        if (!option.duration) {
          option.duration = 2000;
        }
      }
    } else {
      option = {
        showClose: true,
        duration: 2000,
      };
    }
    return Message(option);
  };

  Vue.prototype.$message.success = function (msg) {
    return Message.success({
      message: msg,
      showClose: true,
      duration: 2000,
    });
  };
  Vue.prototype.$message.warning = function (msg) {
    return Message.warning({
      message: msg,
      showClose: true,
      duration: 2000,
    });
  };
  Vue.prototype.$message.error = function (msg) {
    return Message.error({
      message: msg,
      showClose: true,
      duration: 2000,
    });
  };

  Vue.prototype.$message.info = function (msg) {
    return Message.info({
      message: msg,
      showClose: true,
      duration: 2000,
    });
  };
}
